import { render, staticRenderFns } from "./KelompokAngsuran.vue?vue&type=template&id=74be01c7"
import script from "./KelompokAngsuran.vue?vue&type=script&lang=js"
export * from "./KelompokAngsuran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports